import React, { useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import SuccessScreen from '../MessagesScreens/SuccessScreen';
import { t } from 'i18next';
import accessSuccessIcon from '../../assets/icons/success-entry-icon.svg'
import exitSuccessIcon from '../../assets/icons/success-exit-icon.svg'
import AccessInput from '../Inputs/AccessInput';
import AccessContext from '../../context/AccessContext/AccessContext';
import AccessVehiclesContext from '../../context/AccessVehiclesContext/AccessVehiclesContext';
import AccessPersonToVisitContext from '../../context/AccessPersonToVisitContext/AccessPersonToVisitContext';
import AccessAreaContext from '../../context/AccessAreaContext/AccessAreaContext';
import AccessEquipmentContext from '../../context/AccessEquipment/AccessEquipmentContext';

const SuccessAccess = () => {

    const { accessState, clean } = useContext(AccessContext);
    const { type } = accessState

    const { cleanAccessVehiclesState } = useContext(AccessVehiclesContext);
    const { cleanAccessPersonToVisitState } = useContext(AccessPersonToVisitContext);
    const { cleanAccessAreaState } = useContext(AccessAreaContext);
    const { cleanAccessEquipmentState } = useContext(AccessEquipmentContext);

    const navigate = useNavigate();

    const messagesOptions = {
        ACCESS: {
            message: t('SUCCESS_ACCESS_DESC'),
            image: accessSuccessIcon
        },
        EXIT: {
            message: t('SUCCESS_EXIT_DESC'),
            image: exitSuccessIcon
        },
        ACCESS_VISIT: {
            message: t('SUCCESS_ACCESS_DESC'),
            image: accessSuccessIcon
        },
        EXIT_VISIT: {
            message: t('SUCCESS_EXIT_DESC'),
            image: exitSuccessIcon
        }
    }

    const message = messagesOptions[type];

    useEffect(() => {
        const redirectAfterTime = setTimeout(() => {
            navigate('/dashboard');
            clean();
            cleanAccessVehiclesState();
            cleanAccessAreaState();
            cleanAccessPersonToVisitState();
            cleanAccessEquipmentState();
        }, 3000);
        return () => clearTimeout(redirectAfterTime)
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            <AccessInput />
            <SuccessScreen
                title={t('SUCCESS_SUBMIT_TITTLE')}
                description={message.message}
                image={message.image}
            />
        </div>
    );
}

export default SuccessAccess